<template>
  <div>
    <el-table
      :data="gridData"
      :header-cell-style="{ textAlign: 'center' }"
      :cell-style="{ textAlign: 'center' }"
    >
      <el-table-column label="文件名" center>
        <template slot-scope="props">
          <el-link
            type="primary"
            @click="handleDownload(props.row.link)"
            :underline="true"
            >{{ props.row.link }}</el-link
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
// import download from "downloadjs";

import FileSaver from "file-saver";
export default {
  data() {
    return {
      gridData: [
        {
          link: "PWZQ行星减速机安装说明书.pdf",
        },
        {
          link: "工程行星减速机使用说明书.pdf",
        },
        {
          link: "精密行星减速机安装说明书.pdf",
        },
        {
          link: "脂润滑减速机使用说明书.pdf",
        },
      ],
    };
  },
  methods: {
    // 文件下载
    handleDownload(fileName) {
      // download(encodeURI("/kofon/files/specification/" + file), file);
      const that = this;
      var oReq = new XMLHttpRequest();
      var URL = "/kofon/files/specification/" + fileName; // URL 为URL地址
      oReq.open("GET", URL, true);
      oReq.responseType = "blob";
      oReq.onload = function () {
        var file = new Blob([oReq.response], {
          type: "blob",
        });
        FileSaver.saveAs(file, fileName); // that.name为文件名
      };
      oReq.send();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/view/FileDownLoad.vue